"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationItem_1 = __importDefault(require("../NotificationItem"));
var ItemSold_1 = __importDefault(require("../../Icons/Notifications/ItemSold"));
var schemas_1 = require("@dcl/schemas");
var i18N = {
    en: { description: 'You just sold ', title: 'Item Sold' },
    es: { description: 'Vendiste ', title: 'Item vendido' },
    zh: { description: '你剛剛賣了 ', title: '已售商品' }
};
var ItemSoldNotification = function (_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: {
            url: notification.metadata.image,
            rarity: notification.metadata.rarity,
            icon: react_1.default.createElement(ItemSold_1.default, null)
        }, timestamp: notification.timestamp, isNew: !notification.read },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, i18N[locale].title),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" },
            i18N[locale].description,
            ' ',
            react_1.default.createElement("span", null,
                react_1.default.createElement("a", { href: notification.metadata.link, style: {
                        color: "".concat(schemas_1.Rarity.getColor(notification.metadata.rarity)),
                        textDecoration: 'underline'
                    } }, notification.metadata.nftName)))));
};
exports.default = ItemSoldNotification;
